import { AsyncPipe } from '@angular/common'
import { Component, Input, OnInit, inject } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { Observable } from 'rxjs'
import { SmartQuoteTemplateService } from 'src/app/core/services/smartquote/smartquote-template.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service'
import { InputTextareaComponent } from 'src/app/shared/components/form-elements/input-textarea/input-textarea.component'
import { LabelComponent } from 'src/app/shared/components/form-elements/label/label.component'
import { SmartQuoteTemplate } from 'src/app/shared/interfaces/smartquote-template/smartquote-template.interface'

@Component({
    selector: 'sf-smartquote-job-details',
    imports: [
        ReactiveFormsModule,
        NgbNavModule,
        NgSelectModule,
        LabelComponent,
        InputTextareaComponent,
        CardComponent,
        AsyncPipe,
    ],
    templateUrl: './smartquote-job-details.component.html',
    styleUrl: './smartquote-job-details.component.scss'
})
export class SmartquoteJobDetailsComponent implements OnInit {
    private confirmationService = inject(ConfirmationDialogService)
    private smartQuoteTemplateService = inject(SmartQuoteTemplateService)

    @Input() form!: FormGroup

    smartQuoteTemplates$!: Observable<SmartQuoteTemplate[]>

    ngOnInit(): void {
        this.smartQuoteTemplates$ = this.smartQuoteTemplateService.getSmartQuoteTemplates()
    }

    onJobTypeChange(jobType: SmartQuoteTemplate) {
        this.confirmationService
            .confirm(
                'Are you sure?',
                'Are you sure you want to load this template? This will overwrite the job description field.'
            )
            .then((confirmed) => {
                if (confirmed) {
                    this.form.patchValue({
                        notes: jobType.description,
                    })
                }
            })
    }
}
